interface StandInCapableOrg {
  standInBaseURL?: string | null;
}

/**
 * Returns true iff the organization advertises a stand-in (local server) base URL.
 *
 * Mirrors mobile's stand-in eligibility check (SDK `standInBaseURL` presence). Used to gate the
 * org-picker "Offline Mode" entry — the token is a navigation hint, never an eligibility gate.
 */
export function supportsStandInServer(org: StandInCapableOrg | null | undefined): boolean {
  return !!org?.standInBaseURL;
}

export default supportsStandInServer;
